import React, { useEffect, useState } from 'react';
import FramePlayer from '../utils/FramePlayer';
import anime from 'animejs';
import '../css/common.css';
import '../css/button.css';
import ImageButton from '../utils/ImageButton';
import Piano from '../utils/Piano';
import lang from '../lang.json';

const Module3e = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module3e;

    useEffect(() => {
        var tl = anime.timeline({});
        tl.add({
            targets: '#circle3',
            r: 80,
            duration: 2400,
            easing: 'easeOutElastic(1, .8)',
        }, '0')
            .add({
                targets: '.anim',
                opacity: 0,
                duration: 1,
            }, '0')
            .add({
                targets: '#circle3',
                cx: 160,
                duration: 1600,
                easing: 'easeOutElastic(1, .8)',
            }, '2200')
            .add({
                targets: '#circle2',
                r: 500,
                duration: 8700,
                easing: 'easeOutElastic(1, .8)',
            }, '1400')
            .add({
                targets: '#circle1',
                r: 500,
                duration: 7500,
                easing: 'easeOutElastic(1, .8)',
            }, '1600')
            .add({
                targets: '.svg',
                zIndex: -1,
                duration: 1,
                easing: 'easeOutElastic(1, .8)',
            }, 2700)
            .add({
                targets: '.anim',
                opacity: 1,
                duration: 500,
            }, 2500)

    }, []);

    return (
        <>
            <div className="background" >
                <img src={process.env.PUBLIC_URL + "/assets/images/module3e/1.jpg"}
                    alt="background"
                    style={
                        { position: "absolute", left: 0, top: 0, width: 660, zIndex: 2 }}
                />

                <Piano
                    dirName={"piano3e"}
                    numberOfPages={8}
                    pageSpeeds={[24.5, 24.5, 24.9, 23.5, 24.5, 24.2, 23.5, 12.8]} //Duree de chaque page en sec
                    musicName={"module3e"}
                    height={325}
                    width={650}
                    style={{ position: 'absolute', top: '105px' }}
                    className='anim'
                />

                <img
                    src={process.env.PUBLIC_URL + "/assets/images/module3e/key.png"}
                    alt="piano key"
                    className='anim'
                    style={
                        { position: "absolute", left: 0, top: 105, zIndex: 4 }}
                />


                <svg viewBox="0 0 660 500"
                    style={{ position: "absolute", left: 0, top: 0, width: 660, zIndex: 30 }}
                    className='svg'
                >
                    <mask id="circles"
                        maskUnits="objectBoundingBox" >
                        <rect x="0"
                            y="0"
                            width="100%"
                            height="100%"
                            fill="white" />
                        <circle id="circle1"
                            cx="598"
                            cy="90"
                            r="0"
                            fill="black" />
                        <circle id="circle2"
                            cx="160"
                            cy="90"
                            r="0"
                            fill="black" />
                        <circle id="circle3"
                            cx="370"
                            cy="90"
                            r="0"
                            fill="black" />
                    </mask>

                    <rect x="0"
                        y="0"
                        width="100%"
                        height="100%"
                        fill="black"
                        style={
                            { mask: 'url(#circles)' }}
                    /> </svg>
            </div>
            {/* textes */}
            <p
                style={{
                    position: 'absolute',
                    left: 10,
                    top: 0,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang1}</p>
            <p
                style={{
                    position: 'absolute',
                    left: 20,
                    top: 23,
                    color: 'white',
                    fontSize: '15px',
                    width: 600,
                    zIndex: 15
                }}
                className='anim'
            >{texts.lang30}</p>
        </>
    );
}

export default Module3e;